import React, { PureComponent } from 'react';

import { Bar, Wrapper } from './styled/RatioModelisationStyled';

import { colors } from '../../../../utils/utils';

class RatioModelisation extends PureComponent<{ value?: number }> {
    _getRestPercentage() {
        const { value } = this.props;
        const safeValue = value ?? 0;
        if (!safeValue) return 0;
        return 1 - safeValue;
    }

    render() {
        const value = this.props.value ?? 0;
        return (
            <Wrapper>
                <Bar $color={colors.blue.palatinate_blue} $percentage={value} />
                <Bar $color={colors.gray.silver_sand} $percentage={this._getRestPercentage()} />
            </Wrapper>
        );
    }
}

export default RatioModelisation;
